import { isMobileDevice, isAndroid } from './is_mobile';
import { Strings } from '../assets/common/strings';

export const getDeviceId = (): string => Strings.DeviceOs.Web;

export const getOs = (): Strings.DeviceOs =>
	isMobileDevice ? (isAndroid ? Strings.DeviceOs.Android : Strings.DeviceOs.Ios) : Strings.DeviceOs.Web;